import './RewardsPage.css';
import { resources } from '../../utils/resources';
import { useUI } from '../../hooks/useUI';

import RewardCard from '../RewardCard/RewardCard';
import Navigation from '../Navigation/Navigation';
import ModalWindow from '../ModalWindow/ModalWindow';
import CalcRewards from '../CalcRewards/CalcRewards';

// Функция для форматирования числа с разделением тысяч
function formatNumber(num) {
    if (num >= 1_000_000) {
        return (num / 1_000_000).toFixed(2).replace('.', ',') + 'М';
    }

    if (Number.isInteger(num)) {
        return num.toLocaleString('en');
    } else {
        return num.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
}

const RewardsPage = (props) => {
    const { userData, selectedWallet } = useUI();

    // Находим кошелёк, соответствующий selectedWallet
    const selectedWalletData = userData?.user_wallets?.find(
        (wallet) => wallet.wallet_id === selectedWallet?.wallet_id
    );



    // Получаем массив наград для выбранного кошелька
    const rewards = selectedWalletData?.wallet_rewards || [];
    // const rewards = selectedWallet?.wallet_rewards || [];

    return (
        <div className='rewardsPage' style={{ backgroundImage: `url(${resources.images.bgLight})` }}>
            <div className="container">
                <div className='rewardsPage__title appearanceAnimation'>Rewards</div>
                <div className="rewardsPage__faq">
                    <div className="rewardsPage__faqTitle appearanceAnimation">
                        <div className="rewardsPage__faqIcon">
                            <img src={resources.icons.faq} alt="" />
                        </div>
                        How does it works?
                    </div>
                    <div className="rewardsPage__faqText appearanceAnimation">
                        Acquire our exclusive tokens, stake them securely on the platform, and enjoy rewards equivalent to gold, silver, and copper—all with transparency and ease.
                    </div>
                </div>
                <div className='rewardsPage__list'>
                    {rewards.length > 0 ? (
                        rewards.map((reward) => (
                            <RewardCard
                                key={reward.asset_id}
                                id={{ id: reward.asset_id.toString() }}
                                value={formatNumber(reward.balance)}
                                currencyIcon={reward.icon || resources.icons.eth}
                                currencyName={reward.asset_name}
                                hourlyPercent={reward.hourly_percent}
                                assetId={reward.asset_id}
                            />
                        ))
                    ) : (
                        <div className="rewardsPage__empty appearanceAnimation">No rewards available</div>
                    )}
                </div>
            </div>
            <Navigation />
            <ModalWindow title='Calculate reward' content={<CalcRewards />} />
        </div>
    );
};

export default RewardsPage;